import Intl from './ReactIntl'

export default Intl.Consumer
